export default "__VITE_ASSET__Bs65fRDQ__"